import { Theme } from "@mui/material";

export const getCartStyles = (isMobile: boolean, isCartPage: boolean) => ({
  border: "none",
  position: "relative",
  display: `${isMobile || !isCartPage ? "block" : "flex"}`,
  justifyContent: "space-between",
  width: "100%",
});

export const getImageWrapperStyles = (
  isCartPage: boolean,
  isSubscription: boolean,
  isMobile: boolean,
  theme: Theme
) => ({
  width: { xs: isCartPage ? 88 : 70, sm: isCartPage ? 174 : 70 },
  height: { xs: isCartPage ? 88 : 70, sm: isCartPage ? 174 : 70 },
  boxSizing: "border-box",
  overflow: "hidden",
  bgcolor: isCartPage ? "background.default" : "transparent",
  border: "1px solid transparent",
  borderColor: isCartPage ? "transparent" : theme.palette.grey[200],
  borderRadius: "8px",
  padding: `${
    isSubscription
      ? 0
      : !isCartPage
      ? theme.spacing(0.5)
      : isCartPage && isMobile
      ? theme.spacing(1.5)
      : theme.spacing(3)
  }`,
});

export const imageStyles = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
};

export const cartContentStyles = (
  isCartPage: boolean,
  isMobile: boolean,
  theme: Theme
) => ({
  flex: 1,
  display: `${isMobile ? "block" : "flex"}`,
  flexDirection: "column",
  justifyContent: "space-between",
  paddingY: `${
    !isCartPage
      ? `${theme.spacing(1.25)} !important`
      : isCartPage && isMobile
      ? `${theme.spacing(0.5)} !important`
      : `${theme.spacing(3)} !important`
  }`,
  paddingX: "0 !important",
});

export const counterStyles = {
  "& .MuiBox-root": {
    width: { xs: 42, md: 52 },
    height: { xs: 34, md: 50 },
    fontSize: "1rem",
  },
  "& .MuiButton-root": {
    width: { xs: 34, md: 40 },
    height: { xs: 34, md: 50 },
    fontSize: "1rem",
  },
};
